import React, { useEffect, useState } from "react";
import {
  flag1,
  flag2,
  flag3,
  flag4,
  flag5,
  flag6,
  flag7,
  flag8,
  flag9,
} from "../../../assets/images";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const Partners = () => {
  const { t, i18n } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

  // Bayraklar dizisi
  const flags = [
    { id: 1, image: flag1 },
    { id: 2, image: flag2 },
    { id: 3, image: flag3 },
    { id: 4, image: flag4 },
    { id: 5, image: flag5 },
    { id: 6, image: flag6 },
    { id: 7, image: flag7 },
    { id: 8, image: flag8 },
    { id: 9, image: flag9 },
  ];

  useEffect(() => {
    const textTimer = setTimeout(() => {
      setShowText(true);
    }, 500);

    const buttonTimer = setTimeout(() => {
      setShowButton(true);
    }, 1500);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(buttonTimer);
    };
  }, [activeIndex]);

  return (
    <div className="md:max-w-container md:mt-[104px] mt-[64px] max-w-containerSm mx-auto">
      <p className="text-black text-3xl md:text-[46px] font-medium text-center mb-8 md:mb-0">
        {t("Beynəlxalq Əməkdaşlıqlarımız")}
      </p>
      <div className="hidden md:block mt-[56px]">
        <Swiper
          slidesPerView={6}
          spaceBetween={20}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          navigation={true}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {flags.map((flag, index) => (
            <SwiperSlide key={flag.id}>
              <a href={`/partners/${flag.id}`}>
                <img
                  className="h-[128px] w-[194px]"
                  src={flag.image}
                  alt={`Flag ${index + 1}`}
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="block md:hidden">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          onSlideChange={(swiper) => {
            setShowText(false);
            setShowButton(false);
            setActiveIndex(swiper.activeIndex);
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {flags.map((slide, index) => (
            <SwiperSlide key={index}>
              <a href={`/partners/${slide.id}`}>
                <div key={index}>
                  <img src={slide.image} alt={`Flag ${index + 1}`} />
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Partners;
